import React from 'react';
import { Star } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function Testimonials() {
  return <div className="bg-sage-light/20 border-y border-beige-muted/50" data-id="element-233">
      <Section data-id="element-234">
        <SectionTitle data-id="element-235">Lo que dicen las mamás que ya lo aplicaron</SectionTitle>
        <p className="text-center text-charcoal-light mb-12 max-w-2xl mx-auto" data-id="element-236">
          Resultados reales. Familias reales. En pocos días.
        </p>

        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-237">
          {/* Card 1 — Classic */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-238">
            <div className="flex items-center gap-4 mb-4" data-id="element-239">
              <div className="w-12 h-12 rounded-full bg-sage flex items-center justify-center flex-shrink-0" data-id="element-240">
                <span className="text-white font-bold text-sm" data-id="element-241">VR</span>
              </div>
              <div data-id="element-242">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-243">
                  Valentina Rodríguez
                </h3>
                <p className="text-sm text-charcoal-light" data-id="element-244">
                  Mamá de Emilio, 6 meses — Córdoba · Con lactancia
                </p>
              </div>
            </div>

            <div className="inline-flex self-start bg-cta/10 text-cta text-sm font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-245">
              De 6 despertares a 1 — en 10 días
            </div>

            <div className="flex gap-1 mb-4" data-id="element-246">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-247" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-248">
              "Yo pensaba que era normal que mi bebé se despertara cada 2 horas.
              Después de aplicar el método, en 10 días pasó a dormir 5 horas
              seguidas. No lo puedo creer todavía."
            </p>
          </div>

          {/* Card 2 — WhatsApp Style */}
          <div className="bg-[#F0EDE8] rounded-2xl shadow-sm border border-beige-muted/50 overflow-hidden flex flex-col" data-id="element-249">
            {/* WhatsApp Header */}
            <div className="bg-[#075E54] px-5 py-3 flex items-center gap-3" data-id="element-250">
              <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0" data-id="element-251">
                <span className="text-white text-xs font-bold" data-id="element-252">LC</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-253">
                <span className="text-white font-medium text-sm" data-id="element-254">
                  Luciana C.
                </span>
                <div className="w-2 h-2 rounded-full bg-green-400" data-id="element-255"></div>
              </div>
            </div>

            {/* Message Area */}
            <div className="p-5 flex-1" data-id="element-256">
              <div className="bg-white rounded-2xl rounded-tl-sm p-4 shadow-sm max-w-[95%] relative" data-id="element-257">
                <p className="text-charcoal text-[15px] leading-relaxed" data-id="element-258">
                  Chicas les cuento que llevamos 12 días con el método y Martina
                  (9 meses) ya duerme su primera siesta de corrido. Ayer a la
                  noche se despertó UNA sola vez. Estoy llorando de emoción 😭
                </p>
                <div className="flex justify-end mt-2" data-id="element-259">
                  <span className="text-xs text-charcoal-light/60" data-id="element-260">
                    14:32 ✓✓
                  </span>
                </div>
              </div>

              <p className="text-xs text-charcoal-light/60 mt-3 ml-1" data-id="element-261">
                Hace 3 días
              </p>
            </div>

            {/* Footer Label */}
            <div className="px-5 pb-4" data-id="element-262">
              <p className="text-sm text-charcoal-light" data-id="element-263">
                Luciana — Buenos Aires
              </p>
            </div>
          </div>

          {/* Card 3 — Classic */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-264">
            <div className="flex items-center gap-4 mb-4" data-id="element-265">
              <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center flex-shrink-0" data-id="element-266">
                <span className="text-white font-bold text-sm" data-id="element-267">SM</span>
              </div>
              <div data-id="element-268">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-269">
                  Sofía Méndez
                </h3>
                <p className="text-sm text-charcoal-light" data-id="element-270">
                  Mamá de Tomás, 11 meses — Rosario · Sin lactancia
                </p>
              </div>
            </div>

            <div className="inline-flex self-start bg-cta/10 text-cta text-sm font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-271">
              Primera noche completa — día 8
            </div>

            <div className="flex gap-1 mb-4" data-id="element-272">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-273" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-274">
              "Mi hijo no dormía toda la noche y yo estaba agotada. Esto nos
              devolvió la paz en casa. Vale cada peso."
            </p>
          </div>
        </div>
      </Section>
    </div>;
}